
let Plugin = function (Vue) {
    this.Vue = Vue;
    this.tokenizingCaptions = [];
    this.tokenizingHistory = {};
    this.captionTokenizer = null;
    this.stopTokenizeSentence = false;
    this.tokenizeErrorCount = 0;
};

Plugin.prototype.tokenizeCaption = function (tmId, caption) {
    // 下面要移到 caller
    if (caption.Id in this.tokenizingHistory) {
        // already tokenized it before
        return false;
    }

    this.tokenizingCaptions.push({
        TeachingMaterialId: tmId,
        VideoCaption: caption,
    });
    this.tokenizingHistory[caption.Id] = caption;

    if (this.tokenizingCaptions.length > 0 && !this.captionTokenizer) {
        // create the tokenizer
        this.doTokenizeCaption();
    }
};

Plugin.prototype.doTokenizeCaption = async function () {
    if (this.captionTokenizer) {
        console.log('The tokenizer already exist, skip creating it.');
        return;
    }

    let tokCap = this.tokenizingCaptions.pop();
    let tmId = null, caption = null;

    if (tokCap) {
        tmId = tokCap.TeachingMaterialId;
        caption = tokCap.VideoCaption;
    }

    if (!caption) {
        console.log('No more caption in tokenizing queue, skip tokenizer creation.');
        return;
    }

    if (this.stopTokenizeSentence) {
        console.log('The sentence tokenizing is stopped.');
        return;
    }

    try {
        let res = await this.Vue.axios.post("Data/TokenizeVideoCaption", {
            tmId: tmId,
            lang: caption.Lang,
            cid: caption.Id,
        });

        let data = res.data;

        if (data.success) {
            this.Vue.set(caption, 'tokenizedCaption', data.data);   // cache the tokenized caption
            this.doTokenizeCaption();
        } else {
            // failed to tokenizing caption
            this.tokenizeErrorCount++;
            if (this.tokenizeErrorCount == 1) {
                // [TODO] alert message here 
                alert(data.message);
            } else if (this.tokenizeErrorCount >= 3) {
                this.stopTokenizeSentence = true;
            }
        }
    } catch (error) {
        if (error.response) {
            // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
            // 有 data / status / headers 參數可用
            console.log(error.response.status);
        } else if (error.request) {
            // 發送請求，但沒有接到回應
            // error.request is an instance of XMLHttpRequest in the browser
            // and an instance of http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // 在設定 request 時出錯會進入此
            console.log("Error", error.message);
        }

        console.log('Failed to tokenize video caption, id: ' + caption.Id);
        this.captionTokenizer = null;
        this.tokenizeErrorCount++;
        if (this.tokenizeErrorCount == 1) {
            alert('字幕無法進行分詞處理，發生非預期的結果，請聯絡系統管理員。');
        } else if (this.tokenizeErrorCount >= 3) {
            this.stopTokenizeSentence = true;
        }
    }
};


Plugin.prototype.generateSentenceCht = function (data) {
    var sentence = '';
    var tokens = data.Tokens;

    for (var i = 0; i < tokens.length; i++) {
        var curToken = tokens[i].Title;
        if (curToken.length > 1) {
            sentence = sentence + '<span class="cht_phrase">' + curToken + '</span>';
        } else {
            sentence = sentence + curToken;
        }
    }

    return sentence;
};

Plugin.prototype.generateSentence2 = function (data) {
    var tokens = data.Tokens;
    var userTokens = data.UserTokens;
    var sentence = '';

    // we preprocess to collect the multi-syllable user tokens position
    var curSyllabllPos = 0;
    var userMultiSylPos = {};

    if (userTokens) {   // it's possible encounter empty sentence
        for (let i = 0; i < userTokens.length; i++) {
            let curToken = userTokens[i];
            let words = curToken.split(' ');

            console.log('curToken: ' + curToken);
            if (words.length > 1) {
                userMultiSylPos[curSyllabllPos] = 'S';
                userMultiSylPos[curSyllabllPos + words.length - 1] = 'E';
            }
            curSyllabllPos += words.length;
        }
    }


    curSyllabllPos = 0;
    if (tokens) {   // it's possible encounter empty sentence
        for (let i = 0; i < tokens.length; i++) {
            let curToken = tokens[i].Title;
            let words = curToken.split(' ');
            let tokenClasses = [];

            if (tokens[i].HashedId) {
                tokenClasses.push('lookup-lex');
            }

            if (words.length > 1) {
                tokenClasses.push('phrase');

                // 2+ words phrase
                if (i > 0) {
                    sentence = sentence + ' ';
                }

                let sentenceClasses = tokenClasses.join(" ");
                sentence = sentence + '<span class="' + sentenceClasses + '">';

                var phrase = [];
                for (var j = 0; j < words.length; j++) {
                    if (userMultiSylPos[curSyllabllPos + j] == 'S') {
                        phrase.push('<font color="Red">[');
                    }
                    phrase.push(words[j]);
                    if (userMultiSylPos[curSyllabllPos + j] == 'E') {
                        phrase.push(']</font>');
                    }
                }
                sentence = sentence + phrase.join(' ') + '</span>';
                curSyllabllPos += words.length;
            } else {
                if (i > 0) {
                    sentence = sentence + ' ';
                }

                // 如果有框使用者詞彙（開頭）
                if (userMultiSylPos[curSyllabllPos] == 'S') {
                    sentence = sentence + '<font color="Red">[ ';
                }

                // 本次的詞彙
                let spanClassString = tokenClasses.join(" ");
                let spanString = '<span class="' + spanClassString + '">';
                sentence = sentence + spanString + curToken + '</span>';

                // 如果有框使用者詞彙（結尾）
                if (userMultiSylPos[curSyllabllPos] == 'E') {
                    sentence = sentence + ' ]</font>';
                }
                curSyllabllPos++;
            }
        }
    }

    return sentence;
},

Plugin.install = function (Vue, options) {
    Vue.CaptionTokenizer = new Plugin(Vue, options);

    Object.defineProperties(Vue.prototype, {
        $CaptionService: {
            get() {
                return Vue.CaptionTokenizer;
            }
        }
    });
};

export default Plugin;